import { render, staticRenderFns } from "./SubmittedSap.vue?vue&type=template&id=090aacbc"
import script from "./SubmittedSap.vue?vue&type=script&lang=js"
export * from "./SubmittedSap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports